<form *ngIf="!showPersonalDataForm" action="" class="mt-1" [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="flex justify-center items-center h-full pt-32">
    <div class="w-[500px] px-20 py-10 shadow-2xl bg-white rounded-xl">
      <div class="flex justify-center items-center pb-8">
        <img class="justify-end items-end" src="../../../assets/logo-white.png" class="justify-end items-end">
      </div>
      <custom-input class="mt-3 block w-full opacity-60" formControlName="username" label="User" placeholder="Email" [trimOnBlur]="true"></custom-input>

      <custom-input class="mt-3 block w-full opacity-60" formControlName="password" label="Password" type="password"></custom-input>

      <div *ngIf="isRedirectLoginInProgress" class="mt-4 flex items-center justify-center gap-3 text-sm text-slate-500">
        <div class="h-4 w-4 animate-spin rounded-full border-2 border-slate-300 border-t-yellow-900"></div>
        <span>Signing in...</span>
      </div>

      <div class="mt-5" [ngClass]="isValid() ? [''] : ['opacity-60']">
        <text-button name="Log In" styles="bg-yellow-900 w-full font-bold text-lg hover:opacity-90">
        </text-button>
      </div>

      <div class="mt-3 items-center pt-6">
        <p class="cursor-pointer text-center font-sans text-lg font-light opacity-80" translate>
          Don't have an account? <strong translate class="font-medium text-lg font-sans opacity-90"
            (click)="navToPlatform()" translate>Request a demo</strong>
        </p>
        <p class="cursor-pointer underline mt-3 text-center" translate routerLink="/recovery-password">
          Have you forgotten your password?
        </p>
      </div>
    </div>
  </div>
</form>

<form *ngIf="showPersonalDataForm" class="mt-1" [formGroup]="profileForm" (ngSubmit)="updatePersonalData()">
  <div class="flex justify-center items-center h-full pt-24">
    <div class="w-[560px] px-20 py-10 shadow-2xl bg-white rounded-xl">
      <div class="flex justify-center items-center pb-6">
        <img class="justify-end items-end" src="../../../assets/logo-white.png" class="justify-end items-end">
      </div>

      <div class="text-center mb-6">
        <h2 class="text-2xl font-semibold text-[#343741]" translate>Personal data</h2>
      </div>

      <custom-input
        class="mt-3 block w-full opacity-90"
        formControlName="firstName"
        label="First name"
        [maxlength]="20"
        [trimOnBlur]="true"
        [customErrors]="[{ error: 'pattern', message: 'Only letters should be used' | translate }]"
      ></custom-input>

      <custom-input
        class="mt-3 block w-full opacity-90"
        formControlName="lastName"
        label="Last name"
        [maxlength]="25"
        [trimOnBlur]="true"
        [customErrors]="[{ error: 'pattern', message: 'Only letters should be used' | translate }]"
      ></custom-input>

      <mat-form-field class="mt-3 w-full opacity-90">
        <mat-label translate>Gender</mat-label>
        <mat-select formControlName="gender">
          <mat-option value="male">{{ 'Male' | translate }}</mat-option>
          <mat-option value="female">{{ 'Female' | translate }}</mat-option>
          <mat-option value="other">{{ 'Other' | translate }}</mat-option>
          <mat-option value="x">{{ 'I prefer not to mention' | translate }}</mat-option>
        </mat-select>
        <mat-error *ngIf="profileForm.controls['gender'].hasError('required')" translate>
          Required field
        </mat-error>
      </mat-form-field>

      <mat-form-field class="mt-3 w-full opacity-90">
        <mat-label translate>Date of birth</mat-label>
        <input
          matInput
          [matDatepicker]="birthdayPicker"
          formControlName="birthday"
          [max]="maxBirthDate"
          readonly
          (click)="birthdayPicker.open()"
        >
        <mat-datepicker-toggle matSuffix [for]="birthdayPicker"></mat-datepicker-toggle>
        <mat-datepicker #birthdayPicker></mat-datepicker>
        <mat-error *ngIf="profileForm.controls['birthday'].hasError('required')" translate>
          Required field
        </mat-error>
      </mat-form-field>

      <button
        type="submit"
        class="mt-6 w-full rounded-lg bg-yellow-900 text-white p-3 text-lg font-bold hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed"
        [disabled]="profileUpdating || profileForm.invalid"
      >
        {{ 'Save' | translate }}
      </button>
    </div>
  </div>
</form>
